import ResourcePlanning from "./ResourcePlanning";

export default ResourcePlanning;